import * as _ from "lodash";

import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { AdminMain } from "src/pages/Admin/index";
import ViewProductDetailsPage from "src/pages/Customer/Products/ViewProductDetailsPage";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import CategoriesPage from "./Categories/CategoriesPage";
import CategoryPage from "./Categories/CategoryPage";
// import  PriceListChangePage from "./PriceLists/PriceListChangePage";
import PriceChangeDatesPage from "./PriceLists/PriceChangeDatesPage";
import PriceListsPage from "./PriceLists/PriceListsPage";
import ApprovalChangeDatesPage from "./ApprovalLists/ApprovalChangeDatesPage";
import AprrovalListsPage from "./ApprovalLists/ApprovalListsPage";
import ProductsManagementPage from "./ProductsManagementPage";
import ProductTagsManagementPage from "./ProductTags/ProductTagsManagementPage";
import ProductReplacement from "./ProductReplacement";
import {
  CreateSubstitutionPage,
  ProductSubstitutionPage,
  ProductSubstitutionsPage,
  EditSubstitutionPage
} from "./Substitutions";

export const AdminProducts: IRoute[] = [
  {
    exact: true,
    path: "/admin/products",
    pageComponent: ProductsManagementPage,
    title: "%PRODUCTS% Management",
    icon: Icons.PRODUCT,
    menuType: "ADMIN_PRODUCTS",
    privateRoute: true,
    permissions: [ "view-product" ],
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    roles: [ "admin" ],
    parent: AdminMain[ 0 ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/products/categories",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: CategoriesPage,
    title: "%PRODUCT% %CATEGORIES%",
    icon: Icons.LAYERS,
    menuType: "ADMIN_PRODUCTS",
    privateRoute: true,
    permissions: [ "view-product" ],
    roles: [ "admin" ],
    parent: AdminMain[ 0 ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/products/tags",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: ProductTagsManagementPage,
    title: "%PRODUCT% Tags",
    icon: Icons.LAYERS,
    menuType: "ADMIN_PRODUCTS",
    privateRoute: true,
    permissions: [ "amend-product" ],
    roles: [ "admin" ],
    modules: [ "product-tag" ],
    parent: AdminMain[ 0 ]
  },
  {
    exact: true,
    path: "/admin/products/price-lists",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: PriceListsPage,
    title: "Price Lists",
    icon: Icons.PRICE,
    menuType: "ADMIN_PRODUCTS",
    privateRoute: true,
    permissions: [ "view-product" ],
    roles: [ "admin" ],
    parent: AdminMain[ 0 ]
  },
  {
    exact: true,
    path: "/admin/products/approval-lists",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: AprrovalListsPage,
    title: "Approval Lists",
    icon: Icons.TICK,
    menuType: "ADMIN_PRODUCTS",
    privateRoute: true,
    permissions: [ "view-product" ],
    roles: [ "admin" ],
    parent: AdminMain[ 0 ],
    modules: [ "product-approval" ]
  },
  {
    exact: true,
    path: "/admin/products/substitutions",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: ProductSubstitutionsPage,
    title: "Product Substitutions",
    menuTitle: "Substitutions",
    icon: Icons.SUBSTITUTION,
    menuType: "ADMIN_PRODUCTS",
    privateRoute: true,
    permissions: [ "view-substitution" ],
    roles: [ "admin" ],
    parent: AdminMain[ 0 ],
    modules: [ "substitution" ]
  }
];

const otherRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/categories/:categoryId",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: CategoryPage,
    title: "%PRODUCT% %CATEGORY%",
    icon: Icons.LAYERS,
    menuType: "EMPTY",
    privateRoute: true,
    permissions: [ "amend-product-categories" ],
    roles: [ "admin" ],
    parent: AdminProducts[ 1 ]
  },
  {
    exact: true,
    path: "/products/:productId",
    pageComponent: ViewProductDetailsPage,
    title: "%PRODUCT% Details",
    allowedContexts: [ "ORDER_PRODUCT_SELECTION", "LIST_PRODUCT_SELECTION" ],
    menuType: "ADMIN_MAIN",
    permissions: [ "view-product" ],
    roles: [ "admin" ],
    privateRoute: true,
    hidden: true
  },
  {
    exact: true,
    path: "/products/:productId",
    pageComponent: ViewProductDetailsPage,
    title: "%PRODUCT% Details",
    allowedContexts: [],
    menuType: "ADMIN_PRODUCTS",
    permissions: [ "view-product" ],
    roles: [ "admin" ],
    privateRoute: true,
    hidden: true,
    parent: _.find(AdminProducts, route => route.path === "/admin/products")
  },
  {
    exact: true,
    path: "/admin/products/substitutions/create",
    pageComponent: CreateSubstitutionPage,
    title: "Create a product substitution",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    allowedContexts: [],
    menuType: "EMPTY",
    roles: [ "admin" ],
    permissions: [ "create-substitution" ],
    privateRoute: true,
    modules: [ "substitution" ],
    parent: _.find(AdminProducts, route => route.path === "/admin/products/substitutions")
  },
  {
    exact: true,
    path: "/admin/products/substitutions/:substitutionId",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: ProductSubstitutionPage,
    title: "Product Substitution",
    allowedContexts: [],
    menuType: "EMPTY",
    roles: [ "admin" ],
    permissions: [ "view-substitution" ],
    privateRoute: true,
    modules: [ "substitution" ],
    parent: _.find(AdminProducts, route => route.path === "/admin/products/substitutions")
  },
  {
    exact: true,
    path: "/admin/products/substitutions/:substitutionId/update",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: EditSubstitutionPage,
    title: "Product Substitution",
    allowedContexts: [],
    menuType: "EMPTY",
    roles: [ "admin" ],
    permissions: [ "amend-substitution" ],
    privateRoute: true,
    modules: [ "substitution" ],
    parent: _.find(AdminProducts, route => route.path === "/admin/products/substitutions")
  }
];

const priceChangeRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/price-lists/:priceListId/changes",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: PriceChangeDatesPage,
    title: "Prices Changes",
    menuType: "EMPTY",
    privateRoute: true,
    permissions: [ "view-price-code" ],
    modules: [ "price-change" ],
    parent: _.find(AdminProducts, route => route.path === "/admin/products/price-lists")
  }
];

const approvalChangeRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/approval-lists/:approvalListId/changes",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: ApprovalChangeDatesPage,
    title: "Approval Changes",
    menuType: "EMPTY",
    privateRoute: true,
    permissions: [ "view-price-code" ],
    modules: [ "product-approval" ],
    parent: _.find(AdminProducts, route => route.path === "/admin/products/approval-lists")
  }
];

export default [
  ...AdminProducts,
  ...otherRoutes,
  ...priceChangeRoutes,
  ...approvalChangeRoutes,
  ...ProductReplacement
];
